import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './slices/authSlice';
import mst07suppReducer from './slices/mst07supp/mst07suppSlice';
import mst07customerReducer from './slices/mst07customer/mst07customerSlice';
import mst07categoryReducer from './slices/mst07category/mst07categorySlice';
import mst07brandReducer from './slices/mst07brand/mst07brandSlice';
import mst07equipReducer from './slices/mst07equip/mst07equipSlice';
import mst07accReducer from './slices/mst07acc/mst07accSlice';
import mst07employeeReducer from './slices/mst07employee/mst07employeeSlice';
import mst07certReducer from './slices/mst07cert/mst07certSlice';
import mst07divisiReducer from './slices/mst07divisi/mst07divisiSlice';
import globalLocationReducer from './slices/globalLocation/globalLocationSlice';
import mst07generalitemReducer from './slices/mst07generalitem/mst07generalitemSlice';
import mst07itemexpenseReducer from './slices/mst07itemexpense/mst07itemexpenseSlice';
import mst07komoditasReducer from './slices/mst07komoditas/mst07komoditasSlice';
import mst07locationReducer from './slices/mst07location/mst07locationSlice';
import mst07partsubReducer from './slices/mst07partsub/mst07partsubSlice';
import mst07partReducer from './slices/mst07part/mst07partSlice';
import mst07pettycashReducer from './slices/mst07pettycash/mst07pettycashSlice';
import mst07projectReducer from './slices/mst07project/mst07projectSlice';
import mst07satuanReducer from './slices/mst07satuanSlice';
import mst07suratijinReducer from './slices/mst07suratijinSlice';
import mst07vendorReducer from './slices/mst07vendorSlice';
import mst07zonaReducer from './slices/mst07zonaSlice';
import adm07groupReducer from './slices/adm07groupSlice';
import adm07programReducer from './slices/adm07programSlice';
import adm07userReducer from './slices/adm07userSlice';
import inv07adjReducer from './slices/inv07adjSlice';
import inv07saldoReducer from './slices/inv07saldo/inv07saldoSlice';
import fin07caReducer from './slices/fin07caSlice';
import fin07costmappingReducer from './slices/fin07costmappingSlice';
import ops07bastReducer from './slices/ops07bastSlice';
import ops07bpbReducer from './slices/ops07bpbSlice';
import ops07bpsReducer from './slices/ops07bpsSlice';
import ops07cmReducer from './slices/ops07cmSlice';
import ops07dailyabsenReducer from './slices/ops07dailyabsenSlice';
import ops07fuelReducer from './slices/ops07fuelSlice';
import mkt07contractReducer from './slices/mkt07contractSlice';


const persistConfig = {
  key: 'root',
  storage,
};

const persistConfigCert = {
  key: 'mst07cert',
  storage,
  whitelist: ['activeTab']
};

const persistConfigEmployee = {
  key: 'mst07employee',
  storage,
  whitelist: ['activeTab']
};

const persistConfigAcc = {
  key: 'mst07acc',
  storage,
  whitelist: ['activeTab']
};

const persistConfigBrand = {
  key: 'mst07brand',
  storage,
  whitelist: ['activeTab']
};

const persistConfigEquip = {
  key: 'mst07equip',
  storage,
  whitelist: ['activeTab']
};

const persistConfigCategory = {
  key: 'mst07category',
  storage,
  whitelist: ['activeTab']
};

const persistConfigCustomer = {
  key: 'mst07customer',
  storage,
  whitelist: ['activeTab']
};

const persistConfigDivisi = {
  key: 'mst07divisi',
  storage,
  whitelist: ['activeTab']
};

const persistConfigSupp = {
  key: 'mst07supp',
  storage,
  whitelist: ['activeTab']
};

const persistConfigGlobalLocation = {
  key: 'globalLocation',
  storage,
  whitelist: ['locationData', 'lastFetched'] // Persist location data and timestamp
};

const persistConfigGeneralitem = {
  key: 'mst07generalitem',
  storage,
  whitelist: ['activeTab']
};

const persistConfigItemexpense = {
  key: 'mst07itemexpense',
  storage,
  whitelist: ['activeTab']
};

const persistConfigKomoditas = {
  key: 'mst07komoditas',
  storage,
  whitelist: ['activeTab']
};

const persistConfigLocation = {
  key: 'mst07location',
  storage,
  whitelist: ['activeTab']
};

const persistConfigPartsub = {
  key: 'mst07partsub',
  storage,
  whitelist: ['activeTab']
};

const persistConfigPart = {
  key: 'mst07part',
  storage,
  whitelist: ['activeTab']
};

const persistConfigPettycash = {
  key: 'mst07pettycash',
  storage,
  whitelist: ['activeTab']
};

const persistConfigProject = {
  key: 'mst07project',
  storage,
  whitelist: ['activeTab']
};

const persistConfigSatuan = {
  key: 'mst07satuan',
  storage,
  whitelist: ['activeTab']
};

const persistConfigSuratIjin = {
  key: 'mst07suratijin',
  storage,
  whitelist: ['activeTab']
};

const persistConfigVendor = {
  key: 'mst07vendor',
  storage,
  whitelist: ['activeTab']
};

const persistConfigZona = {
  key: 'mst07zona',
  storage,
  whitelist: ['activeTab']
};

const persistConfigGroup = {
  key: 'adm07group',
  storage,
  whitelist: ['activeTab']
};

const persistConfigProgram = {
  key: 'adm07program',
  storage,
  whitelist: ['activeTab']
};

const persistConfigUser = {
  key: 'adm07user',
  storage,
  whitelist: ['activeTab']
};

const persistConfigInv07Saldo = {
  key: 'inv07saldo',
  storage,
  whitelist: ['activeTab']
};

const persistConfigInv07Adj = {
  key: 'inv07adj',
  storage,
  whitelist: ['activeTab']
};

const persistConfigFin07Ca = {
  key: 'fin07ca',
  storage,
  whitelist: ['activeTab']
};

const persistConfigFin07Costmapping = {
  key: 'fin07costmapping',
  storage,
  whitelist: ['activeTab']
};

const persistConfigOps07Bast = {
  key: 'ops07bast',
  storage,
  whitelist: ['activeTab']
};

const persistConfigOps07Bpb = {
  key: 'ops07bpb',
  storage,
  whitelist: ['activeTab']
};

const persistConfigOps07Bps = {
  key: 'ops07bps',
  storage,
  whitelist: ['activeTab']
};

const persistConfigOps07Cm = {
  key: 'ops07cm',
  storage,
  whitelist: ['activeTab']
};

const persistConfigOps07DailyAbsen = {
  key: 'ops07dailyabsen',
  storage,
  whitelist: ['activeTab']
};

const persistConfigOps07Fuel = {
  key: 'ops07fuel',
  storage,
  whitelist: ['activeTab']
};

const persistConfigMkt07Contract = {
  key: 'mkt07contract',
  storage,
  whitelist: ['activeTab']
};

const persistedReducer = persistReducer(persistConfig, authReducer);
const persistedCertReducer = persistReducer(persistConfigCert, mst07certReducer);
const persistedEmployeeReducer = persistReducer(persistConfigEmployee, mst07employeeReducer);
const persistedAccReducer = persistReducer(persistConfigAcc, mst07accReducer);
const persistedBrandReducer = persistReducer(persistConfigBrand, mst07brandReducer);
const persistedEquipReducer = persistReducer(persistConfigEquip, mst07equipReducer);
const persistedCategoryReducer = persistReducer(persistConfigCategory, mst07categoryReducer);
const persistedCustomerReducer = persistReducer(persistConfigCustomer, mst07customerReducer);
const persistedSuppReducer = persistReducer(persistConfigSupp, mst07suppReducer);
const persistedDivisiReducer = persistReducer(persistConfigDivisi, mst07divisiReducer);
const persistedGlobalLocationReducer = persistReducer(persistConfigGlobalLocation, globalLocationReducer);
const persistedGeneralitemReducer = persistReducer(persistConfigGeneralitem, mst07generalitemReducer);
const persistedItemexpenseReducer = persistReducer(persistConfigItemexpense, mst07itemexpenseReducer);
const persistedKomoditasReducer = persistReducer(persistConfigKomoditas, mst07komoditasReducer);
const persistedLocationReducer = persistReducer(persistConfigLocation, mst07locationReducer);
const persistedPartsubReducer = persistReducer(persistConfigPartsub, mst07partsubReducer);
const persistedPartReducer = persistReducer(persistConfigPart, mst07partReducer);
const persistedPettycashReducer = persistReducer(persistConfigPettycash, mst07pettycashReducer);
const persistedProjectReducer = persistReducer(persistConfigProject, mst07projectReducer);
const persistedSatuanReducer = persistReducer(persistConfigSatuan, mst07satuanReducer);
const persistedSuratIjinReducer = persistReducer(persistConfigSuratIjin, mst07suratijinReducer);
const persistedVendorReducer = persistReducer(persistConfigVendor, mst07vendorReducer);
const persistedZonaReducer = persistReducer(persistConfigZona, mst07zonaReducer);
const persistedGroupReducer = persistReducer(persistConfigGroup, adm07groupReducer);
const persistedProgramReducer = persistReducer(persistConfigProgram, adm07programReducer);
const persistedUserReducer = persistReducer(persistConfigUser, adm07userReducer);
const persistedInv07AdjReducer = persistReducer(persistConfigInv07Adj, inv07adjReducer);
const persistedInv07SaldoReducer = persistReducer(persistConfigInv07Saldo, inv07saldoReducer);
const persistedFin07CaReducer = persistReducer(persistConfigFin07Ca, fin07caReducer);
const persistedFin07CostmappingReducer = persistReducer(persistConfigFin07Costmapping, fin07costmappingReducer);
const persistedOps07BastReducer = persistReducer(persistConfigOps07Bast, ops07bastReducer);
const persistedOps07BpbReducer = persistReducer(persistConfigOps07Bpb, ops07bpbReducer);
const persistedOps07BpsReducer = persistReducer(persistConfigOps07Bps, ops07bpsReducer);
const persistedOps07CmReducer = persistReducer(persistConfigOps07Cm, ops07cmReducer);
const persistedOps07DailyAbsenReducer = persistReducer(persistConfigOps07DailyAbsen, ops07dailyabsenReducer);
const persistedOps07FuelReducer = persistReducer(persistConfigOps07Fuel, ops07fuelReducer);
const persistedMkt07ContractReducer = persistReducer(persistConfigMkt07Contract, mkt07contractReducer);

const store = configureStore({
  reducer: {
    auth: persistedReducer,
    mst07cert: persistedCertReducer,
    mst07supp: persistedSuppReducer,
    mst07customer: persistedCustomerReducer,
    mst07category: persistedCategoryReducer,
    mst07brand: persistedBrandReducer,
    mst07equip: persistedEquipReducer,
    mst07acc: persistedAccReducer,
    mst07employee: persistedEmployeeReducer,
    mst07divisi: persistedDivisiReducer,
    globalLocation: persistedGlobalLocationReducer,
    mst07generalitem: persistedGeneralitemReducer,
    mst07itemexpense: persistedItemexpenseReducer,
    mst07komoditas: persistedKomoditasReducer,
    mst07location: persistedLocationReducer,
    mst07partsub: persistedPartsubReducer,
    mst07part: persistedPartReducer,
    mst07pettycash: persistedPettycashReducer,
    mst07project: persistedProjectReducer,
    mst07satuan: persistedSatuanReducer,
    mst07suratijin: persistedSuratIjinReducer,
    mst07vendor: persistedVendorReducer,
    mst07zona: persistedZonaReducer,
    adm07group: persistedGroupReducer,
    adm07program: persistedProgramReducer,
    adm07user: persistedUserReducer,
    inv07adj: persistedInv07AdjReducer,
    inv07saldo: persistedInv07SaldoReducer,
    fin07ca: persistedFin07CaReducer,
    fin07costmapping: persistedFin07CostmappingReducer,
    ops07bast: persistedOps07BastReducer,
    ops07bpb: persistedOps07BpbReducer,
    ops07bps: persistedOps07BpsReducer,
    ops07cm: persistedOps07CmReducer,
    ops07dailyabsen: persistedOps07DailyAbsenReducer,
    ops07fuel: persistedOps07FuelReducer,
    mkt07contract: persistedMkt07ContractReducer,
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);
export default store;







